import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseEntityService } from './base-entity.service';
import { Requisition, TrainingSchedule } from '../../models/entities/requisition-model';
import { IRequisitionEntityService } from '../../interfaces/entities/requisition-entity-service-interface';
import { environment } from '../../../environments/environment';
import { lastValueFrom, Observable } from 'rxjs';
import { CourseEntity } from '../../models/entities/course';
import { IWizardService } from '../../interfaces/wizard-service.interface';
import { ResourceConfig } from '../../models/configs/resource-config';
import { BasePluginData } from '../../models/wizard-plugin-models/base-plugin-data';
import { TrainerRequisitionResponse } from '../../models/update-requisition-model';
import { Log, IShortLogger } from '../logger.service';

@Injectable({
  providedIn: 'root'
})
export class RequisitionEntityService extends BaseEntityService<Requisition> implements IRequisitionEntityService {
  private readonly logger: IShortLogger<RequisitionEntityService> = Log.create(RequisitionEntityService);
  constructor(override readonly http: HttpClient) {
    super(http);
  }

  override initializeData(): void {

  }
  override createEntity(entity: Requisition, createdBy: string): Requisition {
    throw new Error('Method not implemented.');
  }
  override updateEntity(id: string, updates: Partial<Requisition>, updatedBy: string): Requisition | null {
    throw new Error('Method not implemented.');
  }

  create1(finalData: { [key: string]: BasePluginData; }, config: ResourceConfig | undefined): void {
    this.logger.i("create1 finalData:", finalData);
    this.logger.i("create1 config:", config);
    const data: any = {
      RequisitionData: finalData["RequisitionData"],
      BillingDetailsData: finalData["BillingDetailsData"],
      TrainingSchedulesData: (finalData["TrainingSchedulesData"] as any)?.["TrainingSchedulesData"],
      AdditionalInformationData: finalData["AdditionalInformationData"]
    };
    const storedUser: string | null = localStorage.getItem('userId');
    const obj = {

      CreatedBy: storedUser,//"Yogesh",
      UpdatedBy: storedUser,//"Yogesh",
      CreatedOn: new Date(),
      UpdatedOn: new Date(),
      Data: data
    }
    this.createRequisition(obj, obj.CreatedBy!);
  }
  async getAllRequisitions(): Promise<any> {

    var res = await lastValueFrom(this.http.get(`${this.serviceUrl}/v1/requisitions`));
    return res;
    this.logger.i("Requisitions fetched: ", this.entities);
  }
  getRequisitionById(id: string): Observable<any> {
    // const req = this.getEntityById(id) ??
    //   (await lastValueFrom(this.http.get(`${this.serviceUrl}/v1/requisitions/${id}`))) as Requisition;
    // return req;

    return this.http.get(`${this.serviceUrl}/v1/requisitions/${id}`);
  }

  async createRequisition(requisition: any, createdBy: string): Promise<Requisition> {
    requisition.createdBy = createdBy;
    const headers = { "content-type": "application/json" };
    const body = JSON.stringify(requisition);

    this.logger.i("Creating Requisition with body: ", body);
    let created = await lastValueFrom(this.http.post(`${this.serviceUrl}/v1/requisitions/new`, body, { headers }));
    return created as Requisition;
  }
  updateRequisition(updates: TrainerRequisitionResponse): Observable<any> {

    const headers = { "content-type": "application/json" };
    const body = JSON.stringify(updates);
    return this.http.put(`${this.serviceUrl}/v1/requisitions/updaterequisitions`, body, { headers });
  }

  updateRequisitionStatus(objRequisition: any): Observable<any> {
    const headers = { "content-type": "application/json" };
    const body = JSON.stringify(objRequisition);
    return this.http.put(`${this.serviceUrl}/v1/requisitions/updaterequisitionstatus`, body, { headers });
  }

  forwardRequisition(objRequistionMovement: any): Observable<any> {
    const headers = { "content-type": "application/json" };
    const body = JSON.stringify(objRequistionMovement);
    return this.http.post(`${this.serviceUrl}/v1/requisitions/forwardrequisition`, body, { headers });
  }



  async create(finalData: { [key: string]: BasePluginData; }, config: ResourceConfig | undefined): Promise<Requisition> {
    this.logger.i("create finalData:", finalData);
    this.logger.i("create config:", config);
    const data: any = {
      RequisitionData: finalData["RequisitionData"],
      BillingDetailsData: finalData["BillingDetailsData"],
      TrainingSchedulesData: (finalData["TrainingSchedulesData"] as any)?.["TrainingSchedulesData"],
      AdditionalInformationData: finalData["AdditionalInformationData"]
    };
    const storedUser: string | null = localStorage.getItem('userId');
    const obj = {

      CreatedBy: storedUser,//"Yogesh",
      UpdatedBy: storedUser,//"Yogesh",
      CreatedOn: new Date(),
      UpdatedOn: new Date(),
      Data: data
    }

    // requisition.createdBy = createdBy;
    const headers = { "content-type": "application/json" };
    const body = JSON.stringify(obj);

    this.logger.i("Creating Requisition with body: ", body);
    let created = await lastValueFrom(this.http.post(`${this.serviceUrl}/v1/requisitions/new`, body, { headers }));
    return created as Requisition;
  }

  async checkDuplicateEnquiry(enquiryId: string): Promise<any> {

    const req = await lastValueFrom(this.http.get(`${this.serviceUrl}/v1/requisitions/checkenquiryidexists/${enquiryId}`));

    return req;
  }

  searchRequisition(searchParameter: any): Observable<any> {
    const headers = { "content-type": "application/json" };
    const body = JSON.stringify(searchParameter);
    return this.http.post(`${this.serviceUrl}/v1/requisitions/search`, body, { headers });
  }

  replaceRequisition(objRequisition: any): Observable<any> {
    const headers = { "content-type": "application/json" };
    const body = JSON.stringify(objRequisition);
    return this.http.put(`${this.serviceUrl}/v1/requisitions/replace`, body, { headers });
  }

  /**
   * Archives a requisition (soft-delete). Blocked by the server if any linked
   * class is still active (returns 409 in that case).
   */
  archiveRequisition(id: string): Observable<void> {
    return this.http.patch<void>(
      `${this.serviceUrl}/v1/requisitions/${encodeURIComponent(id)}/archive`,
      null
    );
  }


}
